import { render } from "./DocumentHandling.vue?vue&type=template&id=150d8a1c"
import script from "./DocumentHandling.vue?vue&type=script&lang=js"
export * from "./DocumentHandling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__